import xhr from './../../utils/xhr';

const api = {
    get: (filters = { pestle: null, payload: null }, sorting = {
        sortBy: "createdDate",
        direction: "DESC"
    }, pagination = {pageSize: -1, pageNumber: -1}) => {
        return xhr.post({
            url: `/api/articles/pestle/${filters.pestle}/?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}`,
            data: filters.payload
        });
    },

    count: (filters = {pestle: null, payload: null}) => {
        return xhr.post({
            url: `/api/articles/count/pestle/${filters.pestle}`,
            data: filters.payload
        });
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/scripts/pages/News/News.api.js